module.exports = __webpack_public_path__ + "static/media/modificarMedioPago_orange.61c9a12a.svg";